import * as React from "react";
import { observer } from "mobx-react-lite";
import { Empty, Form, Modal, Radio, Space, Spin, Tag } from "antd";
import { ZIdName } from "src/types/ZIdName";
import { onError } from "src/common/onError";
import { bom3ControlStore as store } from "./Bom3ControlStore";

type PropsBom3StatesModal = {};

export const Bom3StatesModal: React.FC<PropsBom3StatesModal> = observer(() => {
  const { currentState } = store;
  const [form] = Form.useForm();
  const open = store.stateMode;
  const [loading, setLoading] = React.useState(false);
  const [targetStates, setTargetStates] = React.useState<ZIdName[]>([]);
  React.useEffect(() => {
    setTargetStates([]);
    if (open) {
      form.resetFields();
      setLoading(true);
      store
        .loadStates()
        .then((list) => setTargetStates(list))
        .finally(() => setLoading(false))
        .catch((e) => {
          onError(e);
          store.setStateMode(false);
        });
    }
  }, [open]);
  return (
    <Modal
      title="Изменение состояния экземпляров"
      open={open}
      onCancel={() => store.setStateMode(false)}
      okText="Изменить"
      onOk={() => form.submit()}
      okButtonProps={{
        loading: store.task === "changeState",
        disabled: targetStates.length === 0,
      }}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={({ state }) => store.doChangeState(state)}
      >
        <Form.Item label="Текущее состояние:">
          <Tag color="gold">{currentState?.name}</Tag>
        </Form.Item>
        <Form.Item
          label="Изменить состояние:"
          name="state"
          rules={[{ required: true, message: "Необходимо выбрать состояние" }]}
        >
          <Spin spinning={loading} size="large">
            {targetStates.length === 0 && (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="Нет ни одного состояния для перехода"
              />
            )}
            <Radio.Group>
              <Space direction="vertical">
                {targetStates.map(({ id, name }) => (
                  <Radio key={id} value={id}>
                    {name}
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          </Spin>
        </Form.Item>
      </Form>
    </Modal>
  );
});
